/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  SetToolsetEnvironmentLinkRequestBody,
  SetToolsetEnvironmentLinkRequestBody$Outbound,
  SetToolsetEnvironmentLinkRequestBody$outboundSchema,
} from "../components/settoolsetenvironmentlinkrequestbody.js";

export type SetToolsetEnvironmentLinkSecurity = {
  projectSlugHeaderGramProject?: string | undefined;
  sessionHeaderGramSession?: string | undefined;
};

export type SetToolsetEnvironmentLinkRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  setToolsetEnvironmentLinkRequestBody: SetToolsetEnvironmentLinkRequestBody;
};

/** @internal */
export type SetToolsetEnvironmentLinkSecurity$Outbound = {
  "project_slug_header_Gram-Project"?: string | undefined;
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const SetToolsetEnvironmentLinkSecurity$outboundSchema: z.ZodMiniType<
  SetToolsetEnvironmentLinkSecurity$Outbound,
  SetToolsetEnvironmentLinkSecurity
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.optional(z.string()),
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function setToolsetEnvironmentLinkSecurityToJSON(
  setToolsetEnvironmentLinkSecurity: SetToolsetEnvironmentLinkSecurity,
): string {
  return JSON.stringify(
    SetToolsetEnvironmentLinkSecurity$outboundSchema.parse(
      setToolsetEnvironmentLinkSecurity,
    ),
  );
}

/** @internal */
export type SetToolsetEnvironmentLinkRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
  SetToolsetEnvironmentLinkRequestBody:
    SetToolsetEnvironmentLinkRequestBody$Outbound;
};

/** @internal */
export const SetToolsetEnvironmentLinkRequest$outboundSchema: z.ZodMiniType<
  SetToolsetEnvironmentLinkRequest$Outbound,
  SetToolsetEnvironmentLinkRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    setToolsetEnvironmentLinkRequestBody:
      SetToolsetEnvironmentLinkRequestBody$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
      setToolsetEnvironmentLinkRequestBody:
        "SetToolsetEnvironmentLinkRequestBody",
    });
  }),
);

export function setToolsetEnvironmentLinkRequestToJSON(
  setToolsetEnvironmentLinkRequest: SetToolsetEnvironmentLinkRequest,
): string {
  return JSON.stringify(
    SetToolsetEnvironmentLinkRequest$outboundSchema.parse(
      setToolsetEnvironmentLinkRequest,
    ),
  );
}
